import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import { formatUrl } from '@ifeng/public_method';
import styles from './index.css';
import { getImage } from '../../../../utils/cutImg';
import { rel as relText } from '../../../../utils/rel';
import { classnames } from '../../../../utils/classnames';

class CheZhan extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
        componentOptions: PropTypes.object,
    };
    render() {
        const {
            content,
            componentOptions: { infoTitle, infoUrl },
        } = this.props;

        return (
            <div className={styles.news_group}>
                {/* 标题 */}
                <div className={`${styles.news_group_title} clearfix`}>
                    <i className={classnames(styles.block, 'block')} />
                    <span className={styles.link_title}>{infoTitle}</span>
                    {infoUrl ? (
                        <a className={styles.more} href={infoUrl} target="_blank" rel={relText}>
                            更多&gt;
                        </a>
                    ) : null}
                </div>
                {/* 新闻 */}
                <ul className={classnames(styles.news_list, 'news_list')}>
                    {content.map((item, index) => (
                        <li key={index} className={`${styles.has_image} clearfix`}>
                            <a
                                className={styles.image_link}
                                href={item.url}
                                title={item.title}
                                target="_blank"
                                rel={relText}>
                                <img src={item.image ? getImage(item.image, 342, 126) : undefined} alt={item.title} />
                            </a>
                            <h5 className={styles.image_title}>
                                <a href={item.url} title={item.title} target="_blank" rel={relText}>
                                    {item.title}
                                </a>
                            </h5>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(CheZhan);
